import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import HtmlRegion from '../../../components/htmlRegion';

class Footer extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { footer, introduction, introductionId } = this.props.content;

        return (
            <div className={styles.footer}>
                <Chip id={introductionId} type="static" title="频道介绍" groupName="footer" content={introduction}>
                    <HtmlRegion className={styles.footer2} />
                </Chip>
                <Chip id="30022" type="static" title="footer" groupName="footer" content={footer}>
                    <HtmlRegion className={styles.footer2} />
                </Chip>
            </div>
        );
    }
}

export default Footer;
